import { Link } from 'react-router-dom';

export default function AcreditacionDocumental() {
  const features = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Documentación de Empresas',
      description: 'Gestión completa de documentos corporativos y certificaciones requeridas.'
    },
    {
      icon: 'ri-user-line',
      title: 'Documentación de Trabajadores',
      description: 'Verificación y carga de credenciales, certificados y exámenes ocupacionales.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Documentación de Vehículos',
      description: 'Revisión técnica, permisos de circulación y documentación de transporte.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Habilitación en Faena',
      description: 'Proceso completo de acreditación para ingreso a faenas mineras e industriales.'
    }
  ];

  return (
    <section id="gestion-documental" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Gestión Documental
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Gestión Documental y <span className="text-teal-600">Acreditación</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Ordenamos, verificamos y subimos la documentación de empresas, trabajadores y vehículos para habilitación en faena.
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Nos encargamos de todo el proceso de acreditación documental, asegurando que tu empresa y personal cumplan con los requisitos para operar sin rechazos ni demoras. Gestionamos desde certificados hasta permisos específicos de cada mandante.
            </p>
            <Link
              to="/contacto"
              className="bg-teal-600 text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors inline-flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
            >
              Solicitar contacto
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              
<img
  src="/images/services/control-documental.webp"
  alt="Control Documental"
  width={900}
  height={830}
  loading="lazy"
  decoding="async"
  className="w-full h-full object-cover object-center"
/>

            </div>
            <div className="absolute -bottom-8 -right-8 bg-white rounded-xl p-6 shadow-xl border border-gray-100 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-file-check-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">Rápido</div>
                  <div className="text-sm text-gray-600">Sin rechazos</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:bg-white hover:shadow-lg transition-all border border-gray-100"
            >
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}